class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'

    itemEl.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
